//imports
import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { injectIntl, useIntl } from 'react-intl';
import { Container, Paper, Grid } from '@mui/material';
import cx from 'classnames'
import { useDispatch } from 'react-redux';
import { HasPermission } from "Core/security"
//controls
import Tabs, { TabContainer } from 'Components/Tabs';

//styles
import 'Modules/reports/views/main/main.scss';

//views
import ReportsTab from './components/reportsTab';
import ScheduledTab from './components/scheduleTab'
import ReportSetupSchedule from './components/scheduleTab/.components/reportSetup';

import {
  reportsMainHideReportSetup
} from 'Redux/actions'
import {useParams} from "react-router-dom";

const ReportsMainView = () => {
  const { messages } = useIntl();
  const [currentTab, setCurrentTab] = useState(0);
  const dispatch = useDispatch()
  const showReportSetup = useSelector(state => state.reportsMainRTRedux.showReportSetup)
  const { user } = useSelector(
    (state) => state.securityRedux
  );

  const { id } = useParams();

  const handleChangeTab = (index) => {
    if (index === 1) {
      dispatch(reportsMainHideReportSetup())
    }
    setCurrentTab(index);
  }

  const refClearReportSetup = useRef(null)
  const clearOldData = () => {
      refClearReportSetup.current()
  }

  return (
    <Container maxWidth={false} className={cx("container-view", showReportSetup && "container-view-sidepanel-opened")}>
      <Paper elevation={0} className="container-view-paper-reports">
        <Tabs tab={currentTab} onChange={handleChangeTab}>
          <TabContainer label={messages["reportsView_reports"]} index={0} className="report-tab-container" >
            <ReportsTab handleChangeTab={handleChangeTab} idReport={id}/>
          </TabContainer>
          {
            HasPermission(user, 'sr', [8]) && (
              <TabContainer label={messages["reportsView_scheduled"]} index={1}>
                <ScheduledTab clearOldData={clearOldData} />
                <ReportSetupSchedule messages={messages} refClearReportSetup={refClearReportSetup} />
              </TabContainer>
            )
          }
        </Tabs>
      </Paper>
    </Container>
  );
}

export default injectIntl(ReportsMainView);
